import { camelCase, upperFirst } from 'lodash-es';

const getCategorySubjectType = (
  prefix: string,
  hasLocalNews: boolean,
) => (
  hasLocalNews
    ? upperFirst(`${camelCase(prefix)}Category`)
    : 'Category'
);

export default getCategorySubjectType;
